// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__IT7lO","icon":"Checkbox_icon__edEN9"};